export default __webpack_public_path__ + "static/media/0xe0339c80ffde91f3e20494df88d4206d86024cdf.905a04a9.webp";